<template>
  <nav class="dib fixed-ns relative w-100 bg-white z-1">
    <div class="db center w-100 mw8-ns flex justify-between">
      <router-link :to="{ name: 'home' }" class="dib link navy hover-blue b no-underline flex items-center pa3 brand" href="/">
        <svg class="dib relative v-mid mr2 logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><title>cryptogigs.co</title><path d="M767,604a157.7,157.7,0,0,1,22,80c0,87-71,158-158,158a158.9,158.9,0,0,1-119-54,157.2,157.2,0,0,1-119,54c-87,0-158-71-158-158a155.1,155.1,0,0,1,22-80,157.4,157.4,0,0,1-95-145c0-87,71-158,158-158a140.8,140.8,0,0,1,35,4c7-80,75-143,157-143s150,63,157,143c11-2,23-4,35-4,87,0,158,71,158,158a157.4,157.4,0,0,1-95,145ZM512,12C236,12,12,236,12,512s224,500,500,500,500-224,500-500S788,12,512,12Z" /></svg>
        <span class="dn dib-ns v-mid relative">cryptogigs.co</span>
      </router-link>
      <div class="flex-grow pa3 flex items-center">
        <router-link :to="{ name: 'about' }" class="dn dib-ns f6 link hover-blue pv1 ph2 navy relative mr2">
          About
        </router-link>

        <!-- logged in user -->
        <template v-if="auth.isLoggedIn">
          <router-link :to="{ name: 'chats' }" class="f6 link hover-blue pv1 ph2 navy relative mr2">
            Chats
          </router-link>
          <router-link :to="{ name: 'profile', params: { username: currentUser.username } }" class="f6 link hover-blue pv1 ph2 navy relative mr2">
            My Profile
          </router-link>
          <router-link :to="{ name: 'create' }" class="dib f6 b link hover-blue pv2 ph3 bg-light-green br3 navy relative">
            + New Post
          </router-link>
        </template>

        <!-- logged out user -->
        <template v-else>
          <router-link :to="{ name: 'login' }" class="dib f6 link hover-blue pv1 ph2 navy relative mr2">
            Login
          </router-link>
          <router-link :to="{ name: 'signup' }" class="dib f6 b link hover-blue pv2 ph3 bg-light-green br3 navy relative">
            Start Earning
          </router-link>
        </template>
      </div>
    </div>
  </nav>
</template>

<script>
// import Auth from '@/auth'
export default {
  data () {
    return {
      auth: this.$store.state.auth,
      currentUser: this.$store.state.user
    }
  },
  // created () {
  //   // console.log(this.currentUser)
  //   // this.logout()
  // },
  watch: {
    '$route': 'checkAuth',
    'currentUser': 'checkAuth'
  },
  methods: {
    checkAuth () {
      // console.log(this.$store.state.user)
      this.currentUser = this.$store.state.user
    }
    // logout () {
    //   Auth.logout()
    // }
    // submitSearch () {
    //   this.$store.commit(
    //     'APPNAV_SEARCH',
    //     {
    //       searchText: this.searchText,
    //       searchTimestamp: Date.now()
    //     }
    //   )
    // }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/AppNav.vue